import React from 'react';
import '../app.css'
import {  Navbar, Nav, Button } from "react-bootstrap";
import IncomemaxLogo from "../images/incomemax-logo.svg"
import "./header.style.css";
import { Link, useHistory } from 'react-router-dom';


function Header(){

    const history = useHistory();

    const goToHome = () => {
        history.push('/');
    }

    return (
        <div style={{maxHeight: "75px"}}>
        <div className="header-container">
            <Navbar.Brand className="header-logo" onClick={goToHome}>
                <img src={IncomemaxLogo}/>        
           </Navbar.Brand>
           <p  className="navTypography-header" >
           <p className="text-header">
           Brought to you by {"\xa0"} <a style={{color: "#000"}} href="https://incomemax.org.uk/"> IncomeMax.org.uk</a>
            </p>                 
           </p>
          
           </div>             
             </div>
    )
}

export default Header;